import { inject, Pipe, PipeTransform } from '@angular/core';
import { PICFLOW_CONFIG } from '../../picflow-config';

export const convertToStoryblokCdn = (value: string, storyblokUrl: string): string => {
  if (!value) return value;
  return value.replace('//a.storyblok.com/f/234504', storyblokUrl.replace('https://', '//'));
};

@Pipe({
  name: 'storyblokCdn',
  standalone: true,
})
export class StoryblokCdnPipe implements PipeTransform {
  private config = inject(PICFLOW_CONFIG);
  transform(value: string): string {
    return convertToStoryblokCdn(value, this.config.storyblokUrl);
  }
}
